import { FONT_BASE } from 'game/constants/AppFonts';

// Expected fields:
// email_from
// email_from_abbreviation
// email_to
// email_subject
// email_body
// email_sign_off
// email_sign_off_name

export class DisplayDocumentEmail extends Phaser.GameObjects.Container {
  constructor(scene, data) {
    super(scene);
    scene.add.existing(this);

    this.x = 0;
    this.y = 250;

    this._data = data;
    this.addDocumentDetails();
  }

  addDocumentDetails() {
    const {
      email_from = '',
      email_from_abbreviation = '',
      email_to = '',
      email_subject = '',
      email_body = '',
      email_sign_off = '',
      email_sign_off_name = '',
    } = this._data;

    // email header
    this.email_from = this.scene.add
      .text(99, 25, email_from, {
        fontFamily: FONT_BASE.OPEN_SANS_BOLD,
        fontSize: '22px',
        color: '#000000',
      })
      .setOrigin(0);

    this.email_to = this.scene.add
      .text(99, this.email_from.y + this.email_from.height + 5, `To: ${email_to}`, {
        fontFamily: FONT_BASE.OPEN_SANS_REGULAR,
        fontSize: '22px',
        color: '#000000',
      })
      .setOrigin(0);

    this.email_from_abbreviation_bg = this.scene.add
      .sprite(20, 20, 'ui', 'email_abbv_background')
      .setOrigin(0);

    this.email_from_abbreviation = this.scene.add
      .text(
        this.email_from_abbreviation_bg.x + this.email_from_abbreviation_bg.width / 2,
        this.email_from_abbreviation_bg.y + this.email_from_abbreviation_bg.height / 2,
        email_from_abbreviation,
        {
          fontFamily: FONT_BASE.PIXEL_OPERATOR_HB,
          fontSize: '40px',
          color: '#FFFFFF',
        }
      )
      .setOrigin(0.5);

    this.subject = this.scene.add
      .text(20, 113, email_subject, {
        fontFamily: FONT_BASE.OPEN_SANS_BOLD,
        fontSize: '22px',
        color: '#000000',
      })
      .setOrigin(0);

    this.body = this.scene.add
      .text(20, this.subject.y + this.subject.height + 10, email_body, {
        fontFamily: FONT_BASE.OPEN_SANS_REGULAR,
        fontSize: '22px',
        color: '#000000',
        wordWrap: { width: 874 },
      })
      .setOrigin(0);

    this.sign_off = this.scene.add
      .text(20, this.body.y + this.body.height + 10, email_sign_off, {
        fontFamily: FONT_BASE.OPEN_SANS_REGULAR,
        fontSize: '22px',
        color: '#000000',
      })
      .setOrigin(0);

    this.sign_off_name = this.scene.add
      .text(20, this.sign_off.y + this.sign_off.height, email_sign_off_name, {
        fontFamily: FONT_BASE.OPEN_SANS_REGULAR,
        fontSize: '22px',
        color: '#000000',
      })
      .setOrigin(0);

    this.add([
      this.email_from,
      this.email_to,
      this.email_from_abbreviation_bg,
      this.email_from_abbreviation,
      this.subject,
      this.body,
      this.sign_off,
      this.sign_off_name,
    ]);
  }

  shutdown() {
    this.destroy();
  }
}
